import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  getOriginsApiCrud,
  type GetOriginsRequest,
} from "@/generated/fastapi";

export async function getOrigins(
  accessToken: string | null | undefined,
  request: GetOriginsRequest,
) {
  const response = await getOriginsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to retrieve origins (${response.status})`);
  }

  return response.data;
}
